const routesContext = [
  {
    consumerRoutes: ['/alerts'],
  },
];

export default routesContext;
